import React, { useState } from "react";
import { createWorker } from "tesseract.js";

const ImageToText = () => {
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);

  // API tesseract.js v4 : le worker est créé à la demande (au moment de l'upload),
  // et non au montage de la page — la langue et le core sont chargés via les CDN
  // par défaut. `logger` alimente la barre de progression pendant la reconnaissance.
  const handleImageUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setLoading(true);
    setProgress(0);
    setText("");

    let worker;
    try {
      worker = await createWorker("fra", 1, {
        logger: (m) => {
          if (m.status === "recognizing text") {
            setProgress(Math.round(m.progress * 100));
          }
        },
      });
      const {
        data: { text: recognized },
      } = await worker.recognize(file);
      setText(recognized);
    } catch (err) {
      console.error("OCR (imgToTxt):", err);
      setText("Erreur lors de l'extraction du texte. Réessayez avec une autre image.");
    } finally {
      if (worker) await worker.terminate();
      setLoading(false);
    }
  };

  return (
    <div className="texttoimg">
      <input type="file" onChange={handleImageUpload} className="parameters" />

      {progress > 0 && (
        <div className="progress-bar">
          <div className="progress" style={{ width: `${progress}%` }}></div>
        </div>
      )}

      {loading ? (
        <>
          <div className="loading-text parameters">Extraction en cours...</div>
          <div className="progress-bar">
            <div className="progress" style={{ width: `${progress}%` }}></div>
          </div>
        </>
      ) : (
        <>
          {text.length > 1 && (
            <div className="result-text parameters">{text}</div>
          )}
        </>
      )}
    </div>
  );
};

export default ImageToText;
